module.exports = __webpack_public_path__ + "static/img/1.ea41218.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R32/1.jpg
// module id = so08
// module chunks = 1